import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarWideLeftArrow: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sidebar-wide-left-arrow"><path d="M15.25 9.75L13 12L15.25 14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M2.75 4.75H21.25V19.25H2.75V4.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M7.75 4.75V19.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconSidebarWideLeftArrow;
